import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { FormattedMessage } from 'react-intl'
import { offerPageRoutes } from 'takeovers/utils/constants/takeoverRoutes'
import TriplePointTakeoverBackground from './components/TriplePointTakeoverBackground'
import TriplePointTakeoverBannerContent from './components/TriplePointTakeoverBannerContent'
import TriplePointTakeoverCampaignSubtitle from './components/TriplePointTakeoverCampaignSubtitle'
import TriplePointTakeoverHeroTitle from './components/TriplePointTakeoverHeroTitle'
import TriplePointTakeoverLogo from './components/TriplePointTakeoverLogo'
import TriplePointTakeoverTierIcon from './components/TriplePointTakeoverTierIcon'
import TriplePointTakeoverSearchBanner from './components/TriplePointTakeoverSearchBanner'
import TriplePointTakeoverBannerDescription from './components/TriplePointTakeoverBannerDescription'

import {
  triplePointCampaignId,
  triplePointsRoute,
  triplePointsTakeoverId,
} from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeover.constants'
const societyTriplePointsTakeoverConfig: App.SiteTakeoverConfig = {
  id: triplePointsTakeoverId,
  hideOnLoyaltyRegionMismatch: true,
  verticals: new Set(['home', 'hotel', 'tours', 'cruise', 'experience']),
  offerTypes: new Set<App.OfferType>([
    'hotel',
    'tactical_ao_hotel',
    'bedbank_hotel',
    'direct_tour',
    'partner_tour',
    'connection_tour',
    'cruise',
    'experience',
  ]),
  campaignTags: new Set([triplePointCampaignId]),
  palette: 'default',
  backgroundElement: TriplePointTakeoverBackground,
  searchPage: {
    bannerContent: <TriplePointTakeoverSearchBanner />,
    hideOnMobileScreenSize: true,
  },
  offerPage: {
    bannerContent: <TriplePointTakeoverBannerContent />,
  },
  heroSection: {
    title: <TriplePointTakeoverHeroTitle />,
    subtitle: <TriplePointTakeoverCampaignSubtitle
      heroTakeover
      viewOffersTo={triplePointsRoute}
    />,
    logo: <CSSBreakpoint min="tablet" dynamic showWhenEmpty={false}><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'inverse',
    verticals: new Set(['home']),
    filters: [],
  },
  siteWide: {
    banner: {
      description: <TriplePointTakeoverBannerDescription viewOffersTo={triplePointsRoute} />,
      bannerAction: {
        to: triplePointsRoute,
        hideMobileActionButton: true,
        children: <FormattedMessage
          id="ulGaNEkE5KkKWvB85pa1"
          defaultMessage="View offers"
          
        />,
      },
      align: 'center',
      tabletAlign: 'center',
      logo: <TriplePointTakeoverTierIcon size="small" />,
      showOnHomePage: false,
      palette: 'inverse',
      exceptedRoutes: [
        ...offerPageRoutes,
        // Page visited by wedding guests
        '/:regionCode/weddings/:slug',
      ],
    },
  },
}

export default societyTriplePointsTakeoverConfig
